import React, { useEffect, useState, useRef } from "react";
import VideoConfigCard, {
  VideoConfigCardContainer,
  VideoConfigCardHeader,
} from "../../UIComponents/VideoConfigCard/VideoConfigCard";
import OpenDrawer from "../../VideoConfig/OpenDrawer/OpenDrawer";
import BgMusicTabs from "./BgMusicTabs/BgMusicTabs";
import SmallSearch from "@/pages/VideoClips/MixCutDetail/BgConfig/BgMusicConfig/BgMusicTabs/BgMusicContainer/SmallSearch/SmallSearch";
import {
  IMusicResponse,
  bindingMusic,
  cancelCollectMusic,
  collectMusic,
  deleteCustomizeMusic,
  getBindingVideo,
  getMusicList,
  toFieldGetMusicList,
  toIdGetMyMusicList,
  getMyFavoriteMusicList
} from "@/services/mixCutDetail/mixCutDetail";
import QuickStore from '@/stores/quickCutStore'
import {Checkbox, Message} from "@arco-design/web-react";
import { toJS } from "mobx";
import allowTypeStore from "@/stores/allowTypeStore";
import { useParams, useSearchParams } from "react-router-dom";
import { IMaterialDetail } from "@/services/createSpace/graphQ/getSimpleMedia";
import ChoseDetailPopover from "@/pages/VideoClips/QuickCut/ChoseDetailPopover/ChoseDetailPopover";
import useCoverAndBg from "@/useStore/quickCut/useCoverAndBg";
import {debounce, throttle, cloneDeep} from "lodash";
import { observer } from "mobx-react";
import CommonUpload from '@/components/business/CommonUpload'
const customMusicList = [
  {
    name: "收藏音乐",
    collection_id: 0,
  },
  {
    name: "自定义",
    collection_id: -1,
  },
];

const BgMusicConfig = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams()
  const searchId = searchParams.get('id')
  // const {
  //   data: mp3List,
  //   loading: mp3ListLoadingState,
  //   handleRequest: getPublicMusic,
  // } = useSimpleReuqest<number, IMusicResponse[]>({
  //   request: toIdGetMusicList,
  // });
  // const {
  //   data: favoriteMusicList,
  //   loading: favoriteMusicLoadingState,
  //   handleRequest: getFavoriteMusic,
  // } = useSimpleReuqest<null, IMusicResponse[]>({
  //   request: getFavoriteMusicList,
  // });
  const { background } = QuickStore.quickcutData.settings;
  const [keyWord, setKeyWord] = useState("");
  const [tabList, setTabList] = useState<any[]>([]);
  const [selfMusicList, setSelfMusicList] = useState<IMaterialDetail[]>([]);
  const [activeId, setActiveId] = useState(0);
  const [visibleState, setVisibleState] = useState(true);
  const [uploadVisible, setUploadVisible] = useState(false);
  const { bgAudio } = useCoverAndBg();
  const [searchMusic, setSearchMusicList] = useState([]);
  const [searchLoading,setSearchLoading] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [focusFlag, setFocusFlag] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [mp3List, setMp3List] = useState([]);
  const [page, setPage] = useState(1);
  const [favoriteMusicList, setFavoriteMusicList] = useState([]);
  const isUserAction = useRef(false);
  const [favoriteMusicLoadingState, setFavoriteMusicLoadingState] = useState(false);
  const init = async () => {
    setSearchFlag(false)
    const data = await getMusicList();
    setTabList([...customMusicList, ...data]);
    setActiveId(data[0].collection_id);
    const selfMusicListData = await getBindingVideo(id || searchId);
    setSelfMusicList(selfMusicListData);
  };

  const handleMaterialFileModalOkBtnClick = async (e: any) => {
    try {
      const data = await bindingMusic(
        id || searchId,
        e.map((item) => Number(item.id)),
      );
      const result = await getBindingVideo(id || searchId);
      setSelfMusicList(result);
      setUploadVisible(false);
    } catch (e) {
      console.log(e);
      Message.error("绑定音乐失败！");
    }
  };

  const handleListActiveIdChange = async (e: number) => {
    setSearchFlag(false);
    if (e !== 0 && e !== -1) {
      try {
        // getPublicMusic(e);
      } catch (e) {
        console.log(e);
        Message.error("请求音乐列表失败！");
      }
    }
    if (e === 0) {
      myFavoriteMusicList(page, false);
    }
    setActiveId(e);
  };

  const onMusicCollect = async (musicId: number) => {
    try {
      setSearchFlag(false);
      await collectMusic(musicId);
      getList(page, false);
    } catch (e) {
      console.log(e);
    }
  };

  const handleCancelCollectBtnClick = async (musicId: number) => {
    setSearchFlag(false);
    try {
      await cancelCollectMusic(musicId);
      if (activeId === 0) {
        await myFavoriteMusicList(page, false);
        return;
      }
      if (activeId !== -1) {
        await getList(page, false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const deleteCustomMusic = async (musiceId: number) => {
    try {
      await deleteCustomizeMusic(id, musiceId);
      Message.success("删除自定义音乐成功！");
      const result = await getBindingVideo(id);
      handleCheckStateChange(false, musiceId as number);
      setSelfMusicList(result);
    } catch (e) {
      console.log(e);
      Message.error("删除自定义音乐失败！");
    }
    console.log(musiceId);
  };

  const handleCheckStateChange = (e: boolean, id: number) => {
    if (e) {
      const item = (searchFlag ? searchMusic : activeId === 0 ? favoriteMusicList : mp3List).find((item) => item.id === id);
      background.musics = [
        ...bgAudio,
        { ...item, duration: item.duration * 1000 },
      ]
    } else {
      const index = bgAudio.findIndex((item) => item.id === id);
      bgAudio.splice(index, 1);
      background.musics = [...bgAudio]
    }
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (keyWord) {
      handleSearchMusic()
      getFilterCusMusicList()
    } else {
      setSearchMusicList([])
      handleListActiveIdChange(activeId);
    }
  }, [keyWord]);

  const getFilterCusMusicList = () => {
    if (keyWord) {
      return selfMusicList.filter(item => item.name.includes(keyWord))
    } else {
      return selfMusicList
    }
  }

  const handleSearchMusic = throttle(() => {
    setSearchLoading(true)
    setSearchFlag(true)
    toFieldGetMusicList(keyWord).then(res => {
      setSearchMusicList(res)
      setSearchLoading(false)
    }).catch(e => {
      setSearchLoading(false)
    })
  }, 1000)

  const getList = async(page, isAppend) => {
    setLoading(true);
    const res = await toIdGetMyMusicList({
      collection_id: activeId,
      page: page,
      page_size: 30,
      type: "1",
    });
    setMp3List(prev => isAppend ? [...prev, ...res] : res);
    setHasMore(res.length === 30); // 如果返回数量等于page_size，说明可能还有下一页
    setLoading(false);
  }

  useEffect(() => {
    setPage(1);
    setMp3List([]);
    if (activeId) {
      getList(page, false);
    } else {
      myFavoriteMusicList(page, false);
    }
    setFavoriteMusicList([])
  }, [activeId, page]);

  const myFavoriteMusicList = async(page, isAppend) => {
    setFavoriteMusicLoadingState(true);
    const res = await getMyFavoriteMusicList({
      collection_id: activeId,
      page: page,
      page_size: 30,
    })
    setFavoriteMusicList(prev => isAppend ? [...prev, ...res] : res);
    setHasMore(res.length === 30); // 如果返回数量等于page_size，说明可能还有下一页
    setFavoriteMusicLoadingState(false);
  }

  return (
    <VideoConfigCard>
      <VideoConfigCardHeader
        headerLeft={
          <>
            <OpenDrawer
              state={visibleState}
              handleStateChange={(e) => {
                setVisibleState(e);
              }}></OpenDrawer>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                setVisibleState(!visibleState);
              }}>
              背景音乐
            </span>
          </>
        }
        headerRight={<>
          <div className="flex--between--center">
            <SmallSearch emitFocusFlag={(val) => {
              setFocusFlag(val);
            }} value={keyWord} onChange={setKeyWord} style={{ marginRight: '10px' }} />
            {
              !focusFlag && <ChoseDetailPopover
                    showField={"title"}
                    handleTagCloseBtnClick={(e) => {
                      console.log(e, 'e');
                      handleCheckStateChange(false, e as number);
                      // background.musics.splice(background.musics.findIndex((item) => item.id === e), 1);
                    }}
                    handleClearBtnClick={() => {
                      background.musics = []
                      background.custom_file = []
                      setSelectAll(false)
                    }}
                    opeatorFiled={"id"}
                    data={bgAudio}
                    title={"背景音乐"}
                />
            }
            <Checkbox
              style={{ marginLeft: 5 }}
              checked={selectAll}
              onChange={(checked) => {
                setSelectAll(checked);
                isUserAction.current = true;
                // 获取当前页面的音乐列表
                let currentPageMusic = [];
                if (searchFlag) {
                  currentPageMusic = searchMusic || [];
                } else {
                  if (activeId === 0) {
                    currentPageMusic = favoriteMusicList || [];
                  } else if (activeId === -1) {
                    currentPageMusic = selfMusicList || [];
                  } else {
                    currentPageMusic = mp3List || [];
                  }
                }
                if (checked) {
                  // 全选逻辑：添加当前页未选中的音乐
                  const existingIds = new Set(bgAudio.map(item => item.id));
                  const newItems = currentPageMusic
                    .filter(item => !existingIds.has(item.id))
                    .map(item => ({
                      ...item,
                      duration: item.duration * 1000
                    }));

                  // 检查总数是否超过200
                  const totalCount = bgAudio.length + newItems.length;
                  if (totalCount > 200) {
                    Message.warning('最多只能选择200首音乐');
                    setSelectAll(false);
                    return;
                  }
                  if (newItems.length > 0) {
                    background.musics = [...bgAudio, ...newItems];
                  }
                } else {
                  // 取消全选逻辑：只移除当前页面的音乐
                  const currentPageIds = new Set(currentPageMusic.map(item => item.id));
                  background.musics = bgAudio.filter(item => !currentPageIds.has(item.id));
                }
              }}
            >
              <span style={{ fontSize: 12 }}>全选</span>
            </Checkbox>
          </div>
        </>
      }></VideoConfigCardHeader>
      <VideoConfigCardContainer style={{ padding: 0, overflow: "hidden" }}>
        {visibleState ? (
          <BgMusicTabs
            isUserAction={isUserAction}
            emitIsUserAction={(value) => {
              isUserAction.current = value;
            }}
            keyWord={keyWord}
            getList={(page, isAppend) => {
              console.log(activeId, 'activeId')
              setSelectAll(false)
              if (activeId !== 0) {
                getList(page, isAppend)
              } else {
                myFavoriteMusicList(page, isAppend)
              }
            }}
            hasMore={hasMore}
            favoriteLoading={favoriteMusicLoadingState}
            publicLoading={loading}
            searchLoading={searchLoading}
            handleCancelCollectBtnClick={(id: number) => {
              handleCancelCollectBtnClick(id);
            }}
            handleDeleteCustomMusicItem={(id: number) => {
              deleteCustomMusic(id);
            }}
            handleMusicCollectBtcClick={(id: number) => {
              console.log(background.musics?.length, 'length')
              if (background.musics?.length === 200) {
                Message.warning("最多只能选择200首音乐");
                return
              }
              onMusicCollect(id);
            }}
            selfMusicList={getFilterCusMusicList()}
            list={tabList}
            musicList={ searchFlag ? searchMusic : activeId === 0 ? favoriteMusicList : mp3List}
            favoriteMusicList={favoriteMusicList}
            activeId={activeId}
            handleListActiveIdChange={(e) => {
              setSelectAll(false);
              handleListActiveIdChange(e);
            }}
            handleSelfUploadBlockBtnClick={() => {
              setUploadVisible(true);
            }}
            selectAll={selectAll}
          />
        ) : (
          <></>
        )}
      </VideoConfigCardContainer>
      <CommonUpload
        onCancel={() => {
          setUploadVisible(false);
        }}
        allowType={toJS(allowTypeStore.getAllMusicTypeString())}
        visible={uploadVisible}
        allowMetarial={[2,4]}
        maxCollectionLength={20}
        defaultCollection={[]}
        handleOkBtnClick={(e) => {
          handleMaterialFileModalOkBtnClick(e);
        }}
      />
    </VideoConfigCard>
  );
};

export default observer(BgMusicConfig);
